































































import { Prop, Component, Vue } from "vue-property-decorator";

@Component({
    directives: {
        focus: {
            inserted: function (el) {
                el.focus();
            },
        },
    },
})
export default class AbcModal extends Vue {
    @Prop() readonly title!: string;
    @Prop() readonly modalClass!: string;
    @Prop({ type: Boolean }) isMessage!: boolean;
    @Prop({ type: Boolean, default: false }) showNavbar!: boolean;
    @Prop({ type: Boolean, default: false }) topPinned!: boolean;
    @Prop({ type: Boolean, default: false }) forceModal!: boolean;
    @Prop({ type: Boolean, default: false }) hideFooter!: boolean;
    @Prop({ type: Boolean, default: false }) noPadding!: boolean;
    @Prop({ type: Boolean, default: false }) fullHeight!: boolean;

    private navbarHeight = 55; //px, default, setted dinamically on mounted
    private modalHeaderHeight = 59; //px
    private modalFooterHeight = 70; //px
    private modalDesktopVerticalPadding = 64; //32px top 32px bottom
    private modalMobileVerticalPadding = 40; //20px top 20px bottom
    private modalVerticalPadding = this.modalDesktopVerticalPadding;
    private mdWidth = 768;

    mounted(){
        const navbar = document.getElementsByClassName("frk-navbar") as any;
        if(navbar && navbar.length > 0){
            this.navbarHeight = (navbar[0] as HTMLElement).clientHeight;
        }

        let windowHTML: HTMLElement | null = null;
        let windowWidth = 0;
        windowHTML = this.$refs.modal_container as HTMLElement;
        windowWidth = windowHTML.clientWidth;
        this.modalVerticalPadding = windowWidth !== 0 && windowWidth < this.mdWidth ? this.modalMobileVerticalPadding : this.modalDesktopVerticalPadding;
    }

    private get maxHeight(): number{
        // if(this.showNavbar){
        //     return this.navbarHeight + this.modalVerticalPadding;
        // } else {
            return this.modalVerticalPadding;
        // }
    }
    private get maxBodyHeight(): number{
        if(!this.hasFooter){
            return this.modalHeaderHeight;
        } else {
            return this.modalHeaderHeight + this.modalFooterHeight;
        }
    }

    private get wrapperStyle() {
        return {
            "top": this.showNavbar ? this.navbarHeight + "px" : 0,
        }
    }
    private get modalStyle() {
        return !this.fullHeight ? { "max-height": "calc(100% - " + this.maxHeight + "px)" } : { "height": "calc(100% - " + this.maxHeight + "px)" };
    }
    private get modalBodyStyle() {
        return !this.fullHeight ? { "max-height": "calc(100% - " + this.maxBodyHeight + "px)" } : { "height": "calc(100% - " + this.maxBodyHeight + "px)" };
    }

    private get hasFooter() {
        return !!this.$scopedSlots.footer;
    }

    close() {
        this.$emit("close");
    }

    submit() {
        this.$emit("submit");
    }
}
